import React from 'react'
import AvatarDr from 'assets/images/onboarding/AvatarDr.png'
import './style.scss'

const Introduction = () => {
    return (
        <div className="introductionContainer">
            <div className="introduction">
                <p>“We all have ups and downs with how we’re feeling and that’s completely normal.</p>
                <p>
                    And although there is no wrong or right way to manage your wellbeing, we would recommend checking-in with yourself from
                    time-to-time.”
                </p>

                <div className="doctorIntroduction">
                    <div>
                        <img src={AvatarDr} alt="avatar Dr Jordan" />
                    </div>
                    <div className="doctorInfo">
                        <p>Dr. Iain Jordan</p>
                        <p>Consultant Psychiatrist</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Introduction
